export const getCookie = (cookie: string) => document.cookie.match(`${cookie}=([^;]+)`)?.[1]
export const setCookie = (cookie: string, value: string) =>
	document.cookie = `${cookie}=${value};max-age=${60 * 60 * 24 * 365};samesite=strict`
export const removeCookie = (cookie: string) => document.cookie = `${cookie}=;max-age=0`
